import { Col } from 'react-bootstrap';
import { SectionHeadingMed, HeadingDesc } from '../../../Components/Headings';
import { SimpleButton } from '../../../Components/button';
import CallToAction from '../../../Components/callToAction/CallToAction';
import img1 from '../../../assets/images/png/bloodpressure.png';
import './recomendedDoc.css';

function RecomendedDoc() {
  return (
    <CallToAction
      leftContent={<LeftContent />}
      rightContent={<RightConten />}
    />
  );
}

function RightConten() {
  return (
    <Col md={5} className="order-lg-2 order-1">
      <div>
        <img src={img1} alt="bloodpressure" />
      </div>
    </Col>
  );
}

function LeftContent() {
  return (
    <Col md={7} className="order-lg-1 order-2">
      <div>
        <SectionHeadingMed text="Blood Pressure Monitoring Available Now! Approved and recommended by doctors." />
        <HeadingDesc text="Our HealthCheck technology has been through a series of global clinical trials and is currently in advanced stages of FDA approval." />
        <HeadingDesc text="We developed it so that families everywhere could stay healthy and better informed - Night or Day!" />
        <SimpleButton text="SCAN YOUR VITALS NOW" bgColor="#EF6286" />
      </div>
    </Col>
  );
}

export default RecomendedDoc;
